import { createContext, useContext } from "react";

type QuickTaskContextValue = {
  openQuickTask: () => void;
};

export const QuickTaskContext = createContext<QuickTaskContextValue | null>(null);

export const useQuickTask = (): QuickTaskContextValue => {
  const ctx = useContext(QuickTaskContext);
  if (!ctx) {
    throw new Error("useQuickTask must be used within an AppShell");
  }
  return ctx;
};
